import { render, staticRenderFns } from "./BannerLinks.vue?vue&type=template&id=0cdeb644&scoped=true"
import script from "./BannerLinks.vue?vue&type=script&lang=js"
export * from "./BannerLinks.vue?vue&type=script&lang=js"
import style0 from "./BannerLinks.vue?vue&type=style&index=0&id=0cdeb644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdeb644",
  null
  
)

export default component.exports